import { BotonesRoles, MenuRoles, URLRoles } from "./types";

export const MENU_ROLES: MenuRoles = {
  Developer: ["Form.Read", "Form.Manage"],
};

export const BOTONES_ROLES: BotonesRoles = {
  Developer: {
    Edit: ["Form.Manage"],
  },
};

export const URL_ROLES: URLRoles = {
  Developer: {
    Edit: ["Form.Manage"],
  },
};
